module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form !== null) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('image-control', {
    attrs: {
      "image-id": _vm.form.image_id
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.image_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "image_id", $$v)
      },
      expression: "form.image_id"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "select",
      "id": "company",
      "label": "Show On Company Website</small>",
      "error": _vm.form.errors.get('company'),
      "option_name": 'name',
      "option_value": 'value',
      "options": [{
          name: 'All Companies',
          value: ''
        },
        {
          name: 'Crockett',
          value: 'CF'
        },
        {
          name: 'Bells',
          value: 'BELLS'
        } ]
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "id": "name",
      "label": "Page name",
      "error": _vm.form.errors.get('name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "id": "title",
      "label": "Page title",
      "error": _vm.form.errors.get('title')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "id": "keywords",
      "label": "Page keywords",
      "error": _vm.form.errors.get('keywords')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.keywords),
      callback: function($$v) {
        _vm.$set(_vm.form, "keywords", $$v)
      },
      expression: "form.keywords"
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "textarea",
      "id": "description",
      "label": "Page description",
      "error": _vm.form.errors.get('description')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen(_vm.form, $event)
      }
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.apiBusy
    },
    on: {
      "click": function($event) {
        return _vm.createPage()
      }
    }
  }, [_vm._v("\n                Create Page\n            ")])], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3179b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/pages/PageCreate.vue
// module id = 566
// module chunks = 0